import React from 'react';
import styles from './ContainerCard.module.css';

type CardProps = {
  className?: string;
  children: React.ReactNode;
};

const ContainerCard = (props: CardProps) => {
  return (
    <div className={`${styles.card} ${props.className ? props.className : ''}`}>
      {props.children}
    </div>
  );
};

export default ContainerCard;
